module.exports = __webpack_public_path__ + "img/3f_r_seven@2x.1cc0ed29.png";